// Shows Feefo's all-time service rating (the same figures as the footer
// badge). The element's server-rendered text is the fallback, kept if the
// request fails. One request per page; responses are CDN/browser cached for 24h.
let serviceSummaryRequest;

function fetchServiceSummary() {
  serviceSummaryRequest ??= fetch(
    'https://api.feefo.com/api/10/reviews/summary/service?merchant_identifier=yawn&since_period=ALL'
  )
    .then((response) => (response.ok ? response.json() : null))
    .catch(() => null);
  return serviceSummaryRequest;
}

const locale = document.documentElement.lang || undefined;
const pluralRules = new Intl.PluralRules(locale);
const numberFormat = new Intl.NumberFormat(locale);

// Rounds down to the nearest 1,000 with a "+" (2,101 → "2,000+") so the
// count never overstates; counts under 1,000 are shown exactly.
function formatCount(count) {
  if (count < 1000) return numberFormat.format(count);
  return `${numberFormat.format(Math.floor(count / 1000) * 1000)}+`;
}

class FeefoServiceRating extends HTMLElement {
  connectedCallback() {
    if (this.rendered) return;
    this.rendered = true;

    fetchServiceSummary().then((data) => {
      const count = data?.meta?.count;
      const rating = data?.rating?.rating;
      if (!count || !rating) return;

      const label = pluralRules.select(count) === 'one' ? this.dataset.labelOne : this.dataset.labelOther;
      this.textContent = label.replace('[rating]', rating.toFixed(1)).replace('[count]', formatCount(count));
    });
  }
}

customElements.define('component-feefo-service-rating', FeefoServiceRating);
